export const MAIN_API_URL = "https://hub.delivery-kpg.com";

export const WEBSOCKET_AUTH_URL = MAIN_API_URL + "/api/broadcasting/auth";

//PRE-LOGIN API
export const GET_SETTINGS_API_URL = MAIN_API_URL + "/api/get-settings";
export const LOGIN_API_URL = MAIN_API_URL + "/api/driver-recruiter/login";
export const CHANGE_PASSWORD_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/change-password";
export const VERIFY_EMAIL_FOR_RESET_PASSWORD_URL =
  MAIN_API_URL + "/api/driver-recruiter/verify-email-for-reset";
export const RESET_PASSWORD_URL =
  MAIN_API_URL + "/api/driver-recruiter/reset-password";

export const UPDATE_USER_INFO_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/update-user-info";

export const DASHBOARD_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/dashboard";
export const GET_ACTIVE_DRIVERS_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/active-drivers";
export const GET_TRANSACTION_HISTORY_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/earnings";
export const GET_PAYOUTS_HISTORY_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/payouts";
export const REQUEST_PAYOUT_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/payout/request";

export const BANK_DETAILS_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/bank-details";
export const UPDATE_BANK_DETAILS_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/update-bank-details";
export const GET_REFERRALS_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/referred-drivers";
export const STATISTICS_CHART_DATA_API_URL =
  MAIN_API_URL + "/api/driver-recruiter/statistics";
